<template>
  <div>
    <!-- Start Footer -->
    <footer class="relative pt-12 pb-8 bg-slate-900 dark:bg-gray-950 overflow-hidden">

      <!-- Background decoration -->
      <div class="absolute inset-0 pointer-events-none overflow-hidden">
        <div class="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-orange-600/5 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-600/30 to-transparent"></div>
      </div>

      <div class="container relative z-10">
        <!-- Top divider line -->
        <div class="h-px w-full bg-gradient-to-r from-transparent via-slate-600/50 to-transparent mb-10"></div>

        <div class="grid md:grid-cols-12 items-center gap-6">
          <!-- Logo -->
          <div class="md:col-span-3 footer-logo text-center md:text-left">
            <a href="#" class="inline-block hover:opacity-90 transition-opacity duration-300">
        <img :src="logo" class="h-24" alt="Sultan Flowers Extracts Place" decoding="async" />
            </a>
          </div>

          <!-- Social Icons -->
          <div class="md:col-span-9 md:mt-0 mt-4 footer-socials">
            <ul class="flex flex-wrap justify-center md:justify-end gap-2">
              <li v-for="social in socials" :key="social.title">
                <a
                  :href="social.href" 
                  :target="social.href.startsWith('http') ? '_blank' : undefined"
                  :title="social.title"
                  class="social-btn btn btn-icon btn-sm border rounded-lg border-slate-700 dark:border-slate-800 hover:border-orange-600 bg-slate-800 dark:bg-gray-900 hover:bg-orange-600 dark:hover:bg-orange-600 text-gray-400 hover:text-white transition-all duration-300 hover:scale-110 hover:-translate-y-0.5"
                >
                  <i :class="`uil uil-${social.icon} align-middle`"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <!-- End Footer -->
  </div>
</template>

<script setup>
import logo from '@/assets/logo.png'
import { ref, onMounted, onUnmounted } from 'vue'

const socials = ref([
  { icon: 'facebook-f', title: 'Facebook', href: '#' },
  { icon: 'instagram', title: 'Instagram', href: '#' },
  { icon: 'whatsapp', title: 'Whatsapp', href: '#' },
]);

let observer;
onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.footer-logo, .footer-copy, .footer-socials').forEach(el => {
    observer.observe(el);
  });
});

onUnmounted(() => {
  if (observer) observer.disconnect();
});
</script>

<style scoped>
/* Footer reveal animations */
.footer-logo {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.footer-copy {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease 0.1s, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s;
}
.footer-socials {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease 0.2s, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s;
}
.footer-logo.revealed,
.footer-copy.revealed,
.footer-socials.revealed {
  opacity: 1;
  transform: translateY(0);
}

.social-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>